<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col cols="10" class="instructions-style">
          <p>
            <strong>INSTRUCCIONES</strong>
          </p>
          <p>{{data.instrucciones}}</p>
        </b-col>
        <b-col cols="12" style="text-align: right;">
          <button v-b-modal.modal-vista-previa-flash class="btn btn-primary">Vista previa PDF</button>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col class="flashcard-content">
              <ul class="flashcard-list">
                <li
                  v-for="(carta, index) in data.cartas"
                  @click="toggleCard(carta)"
                  :key="carta.id"
                >
                  <transition name="flip">
                    <div
                      class="cartaFront shadow"
                      :id="`txtCarta${index}`"
                      v-if="!carta.flipped"
                      key="data"
                    >
                      <div v-if="carta.tipo == 1">
                        <p style="margin-top: 50px;">{{carta.data}}</p>
                      </div>
                      <div v-else-if="carta.tipo == 2">
                        <b-img thumbnail fluid :src="$root.setUrlFile(carta.data)" alt="Imagen"></b-img>
                      </div>
                    </div>
                    <div class="cartaBack shadow" v-else key="back">
                      <div v-if="carta.tipo2 == 1">
                        <p style="margin-top: 50px;">{{carta.reverso}}</p>
                      </div>
                      <div v-else-if="carta.tipo2 == 2">
                        <b-img thumbnail fluid :src="$root.setUrlFile(carta.reverso)" alt="Imagen"></b-img>
                      </div>
                    </div>
                  </transition>
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <modal-vista-previa-flash :contenido="data"></modal-vista-previa-flash>
  </b-row>
</template>

<script>

import ModalVistaPreviaFlash from "@/components/ModalVistaPreviaFlash";

//cartas random
export default {
  name: "pre-flashcards",
  components: {
    ModalVistaPreviaFlash
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          index: null,
          flipped: false,
          tag: "FlashCards",
          cartas: [],
          instrucciones: "",
          data: "",
          reverso: ""
        };
      }
    }
  },
  data() {
    return {
      carta: [],
      index: null,
      cartasArry: new Array()
    };
  },
  methods: {
    toggleCard(carta) {
      carta.flipped = !carta.flipped;
    },
  }
};
</script>

<style lang="scss">
#preview {
  margin-top: 20px;
  text-align: center;
}
.flashcard-content {
  text-align: center;

  img {
    width: 200px;
    height: 200px;
  }

  ul {
    display: flex;
    flex-flow: row wrap;
  }

  li {
    list-style-type: none;
    padding: 10px 10px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }
}

.container {
  max-width: 100%;
  padding: 2em;
}

.cartaFront,
.cartaBack {
  display: block;
  width: 300px;
  height: 250px;
  padding: 30px 30px;
  /*background-color: #00897B;*/
  border-radius: 7px;
  margin: 5px;
  text-align: center;
  cursor: pointer;
  position: relative;
  color: #000;
  font-weight: 600;
  font-size: 20px;
  /*-webkit-box-shadow: 9px 10px 22px -8px rgba(209, 193, 209, 0.5);
  -moz-box-shadow: 9px 10px 22px -8px rgba(209, 193, 209, 0.5);
  box-shadow: 9px 10px 22px -8px rgba(209, 193, 209, 0.5);*/
  will-change: transform;
  border: 1px solid #ddd;
}
.flip-enter-active {
  transition: all 0.7s ease;
}

.flip-leave-active {
  display: none;
}

.flip-enter,
.flip-leave {
  transform: rotateX(180deg);
  opacity: 0;
}
.instructions-style {
  margin-top: 20px;
}
</style>